"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.84 7.88l-4-3L16 2l4 3-2.16 2.88zm-1.32 1.76L8 21l-4 1v-4l8.52-11.36 4 3zm-9.694 9.592L6 19.439v-.772l6.92-9.227.8.6-6.894 9.192z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;